/**
 * Set up routing for all Evaluation views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import evaluation views
// import CreateEvaluation from './views/CreateEvaluation.js.jsx';
// import EvaluationList from './views/EvaluationList.js.jsx';
// import SingleEvaluation from './views/SingleEvaluation.js.jsx';
// import UpdateEvaluation from './views/UpdateEvaluation.js.jsx';

class EvaluationRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
      {/**
        <Route exact path="/evaluations" component={EvaluationList} />
        <YTRoute login={true} exact path="/evaluations/new" component={CreateEvaluation} />
        <Route exact path="/evaluations/:evaluationId" component={SingleEvaluation}/>
        <YTRoute login={true} exact path="/evaluations/:evaluationId/update" component={UpdateEvaluation}/>
      */}
      </Switch>
    )
  }
}

export default EvaluationRouter;



// WEBPACK FOOTER //
// modules/evaluation/EvaluationRouter.js.jsx